import { storeToRefs } from "pinia";
import { computed } from "vue";

import { useGlobalStore } from "shared/stores/global";
import { useUserStore } from "shared/stores/user";

export default function useSupportLinking() {
  const { appConfig } = storeToRefs(useGlobalStore());
  const { organisation } = storeToRefs(useUserStore());

  function supportContactOption(option) {
    return organisation.value.support_contact_option === option;
  }

  const mailTo = computed(() => {
    let mail = "";

    if (supportContactOption("account_manager")) {
      mail = `mailto: ${organisation.value.account_manager.email}`;
    }

    if (supportContactOption("customer_success")) {
      mail = `mailto: ${appConfig.value.emails.customerSuccess}`;
    }

    if (supportContactOption("dedicated_support")) {
      mail = `mailto: ${appConfig.value.emails.dedicatedSupport}`;
    }

    return mail;
  });

  const linkText = computed(() => {
    let text = "";

    if (supportContactOption("account_manager")) {
      text = organisation.value.account_manager.email;
    }

    if (supportContactOption("customer_success")) {
      text = appConfig.value.emails.customerSuccess;
    }

    if (supportContactOption("dedicated_support")) {
      text = appConfig.value.emails.dedicatedSupport;
    }

    return text;
  });

  const contactParty = computed(() => {
    let contact = "";

    if (supportContactOption("account_manager")) {
      contact = "your Account Manager";
    }

    if (supportContactOption("customer_success")) {
      contact = "our Customer Success team";
    }

    if (supportContactOption("dedicated_support")) {
      contact = "our Dedicated Support team";
    }

    return contact;
  });

  return {
    contactParty,
    linkText,
    mailTo,
  };
}
